import LogoDigitagroIcon from '@/assets/icons/Logo-Digitagro';
import { OneIDIcon } from '@/common/icons/OneIDIcon';
import { InputControl } from '@/components/controls/input-control';
import { Button } from '@/components/ui/button.tsx';
import { Form } from '@/components/ui/form';
import { useAuth } from '@/features/auth/hooks/useAuth.ts';
import { Loader2 } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthCarousel } from './Carousel';

export const Auth: FC = () => {
  const { t } = useTranslation();
  const { form, isLoading, handleForm, onSubmitOneID } = useAuth();

  return (
    <div className="flex items-center justify-center h-screen space-x-5 overflow-hidden p-[60px] w-full">
      <div className="w-1/2 flex items-center relative h-[calc(100vh-120px)] rounded-3xl overflow-hidden">
        <AuthCarousel />
      </div>
      <Form {...form}>
        <form
          onSubmit={handleForm}
          className="flex justify-center items-center w-1/2"
        >
          <div className="w-[320px] flex flex-col items-center">
            <LogoDigitagroIcon />
            <p className="text-midnight-default text-lg font-medium tracking-[-0.2px] py-10">
              {t('government.crop.monitoring.system')}
            </p>
            <div className="flex flex-col gap-4 w-full">
              <Button
                type="button"
                className={
                  'bg-[#5D30FF] h-10 hover:bg-[#5D30FF]/80 hover:shadow-lg duration-300'
                }
                onClick={onSubmitOneID}
              >
                <OneIDIcon />
                {t('login.with')}
              </Button>
              {/* <KeysDialog selectKey={selectKey} open={open} close={close}>
                <Button
                  className={
                    'bg-[#6CCB5F] h-12 hover:bg-[#6CCB5F]/80 hover:shadow-lg duration-300 w-full '
                  }
                  onClick={() => setOpen(true)}
                >
                  <ERIIcon />
                  {t('login.with.eri')}
                </Button>
              </KeysDialog> */}
            </div>
            <div className="w-full flex items-center gap-4 py-4">
              <div className="w-full h-[1px] bg-midnight-default" />
              <p className="text-sm text-dark-blue">yoki</p>
              <div className="w-full h-[1px] bg-midnight-default" />
            </div>
            <div className="w-full flex flex-col">
              <InputControl
                control={form.control}
                name="username"
                label={t('login')}
              />
              <InputControl
                control={form.control}
                name="password"
                label={t('password')}
                type="password"
              />
              <Button type="submit" isLoading={isLoading}>
                {isLoading && <Loader2 className="animate-spin" />}

                {t('enter')}
              </Button>
            </div>
          </div>
        </form>
      </Form>
    </div>
  );
};
